var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../core';
import './Empty.style.scss';
import { Prop } from 'vue-property-decorator';
let Empty = class Empty extends VueType {
    login() {
        txv.login.openLogin();
    }
    render() {
        if (!txv.login.isLogin()) {
            return <div class="c_empty not_login">
            <img src="https://vfiles.gtimg.cn/wupload/community_activity_conf.act_img/175fb2fb_rnPWvs1J2AHN2f74RzTzls0oOwC8Wp2C.png"></img>
            <span>登录后查看相关内容</span>
            <button class="btn_login" onClick={() => this.login()}>登录</button>
        </div>;
        }
        return <div class="c_empty">
            <img src="https://puui.qpic.cn/vupload/0/20190514_1557833836359_1fqpicnyvtg.png/0"></img>
            <span>{this.title}</span>
        </div>;
    }
};
__decorate([
    Prop({ default: '你还没有任何记录，不如试试这些专属推荐吧~' })
], Empty.prototype, "title", void 0);
Empty = __decorate([
    Component
], Empty);
export default Empty;
// https://puui.qpic.cn/vupload/0/20190514_1557832910369_3gxckitjcv8.png/0
